import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { Infocomponenteeconomico, usoSuelo as fetchUsoSuelo } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';
import SeguridadCiudadana from './seguiridadC';

const ComponentePecuario = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [description, setDescription] = useState('');
    const [descripcionAvicola, setDescriptionAvicola] = useState('');
    const [usoSueloData, setUsoSueloData] = useState([]); // Nuevo estado para los datos de uso de suelo

    useEffect(() => {
        if (municipioId) {
            fetchDataTurismo();
            fetchUsoSueloData();
        }
    }, [municipioId]);

    const fetchDataTurismo = async () => {
        setLoading(true);
        try {
            const response = await Infocomponenteeconomico(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                if (Array.isArray(fetchedData)) {
                    if (fetchedData.length > 0) {
                        setDescription(fetchedData[0].vocacion_pecuaria);
                        setDescriptionAvicola(fetchedData[0].vocacion_avicola);
                    }
                } else {
                    throw new Error('Fetched data is not an array');
                }
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchUsoSueloData = async () => {
        setLoading(true);
        try {
            const response = await fetchUsoSuelo(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setUsoSueloData(fetchedData); // Guardar los datos de uso de suelo en el estado
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const columns = [
        { title: 'Área Municipal', dataIndex: 'area_municipio', key: 'area_municipio' },
        { title: 'Área Agrícola', dataIndex: 'area_agricola', key: 'area_agricola' },
        { title: 'Área Agroforestal', dataIndex: 'area_agroforestal', key: 'area_agroforestal' },
        { title: 'Área Forestal', dataIndex: 'area_forestal', key: 'area_forestal' },
        { title: 'Ganadería', dataIndex: 'ganaderia', key: 'ganaderia' },
        { title: 'Otros Usos', dataIndex: 'otros_usos', key: 'otros_usos' },
        { title: 'Fuente', dataIndex: 'fuente', key: 'fuente' },
    ];

    return (
        <div className="page-content">
            <h3>Vocación Pecuaria</h3>
            {description ? (
                <p className="descripcion">{description}</p>
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
            
            <h3>Vocación Avícola</h3>
            {descripcionAvicola ? (
                <p className="descripcion">{descripcionAvicola}</p>
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
            
            <h3>Uso de Suelo</h3>
            {usoSueloData && usoSueloData.length > 0 ? (
                <Table 
                    columns={columns} 
                    dataSource={usoSueloData} 
                    rowKey="id_uso" 
                    loading={loading} 
                    pagination={false} 
                    footer={() => `${usoSueloData[0].fuente || 'No disponible'}`}
                />
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
            <SeguridadCiudadana municipioId={municipioId}/>
        </div>
    );
    
};

export default ComponentePecuario;
